// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".XQpar{margin-top:12rem}.wWFzp{display:-ms-flexbox;display:flex;-ms-flex-pack:center;border-top:1px solid #e0e8f2;justify-content:center;margin-top:4rem}._2s6Jy{color:#001f5b;-ms-flex-direction:column;flex-direction:column;margin-top:4rem;text-align:center;width:33.3333%}._2s6Jy,._3IU7s{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}._3IU7s{height:48px;height:4.8rem;padding:.5rem;width:48px;width:4.8rem;-ms-flex-pack:center;background-color:#fff;border-radius:8px;justify-content:center}", ""]);
// Exports
exports.locals = {
	"root": "XQpar",
	"platforms": "wWFzp",
	"platform": "_2s6Jy",
	"platform__logoContainer": "_3IU7s"
};
module.exports = exports;
